import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=51803d5c&"
import script from "./ClientSummary.vue?vue&type=script&lang=js&"
export * from "./ClientSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports